export default __webpack_public_path__ + "static/media/9.74a9adcf.jpg";